<template>
  <fanzone-form
    :id='id'
    redirectTo='/#/fanzones-places'
    label='Miejsca'
    :idStepsEvent='false'
    :idsRelatedEvents='true'
    :scenesEditor='false'
  />
</template>

<script>
	import fanzoneForm from '../components/FanzoneForm'
	
	export default {
    props: ['id'],
    components: { fanzoneForm },
	}
</script>
